import { NgModule } from '@angular/core';
import { CommonModule } from "@angular/common";
import { FrameboardComponent } from './frameboard.component';
import { NavbarModule } from '../navbar/navbar.module';
import { RouterModule } from '@angular/router';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
    declarations: [FrameboardComponent],
    exports: [FrameboardComponent],
    imports: [
        CommonModule,
        NavbarModule,
        RouterModule,
        MatTooltipModule
    ],
})
export class FrameBoardModule {
}
